const QuestionMark = () => {
  const logicChannel = sessionStorage.getItem("mylmx-logic");
  const isFrance = logicChannel === "france";
  return (
    <span className="loginQuestionMark">
      <span className="loginQuestionIcon">?</span>
      <img
        className="loginQuestionImg"
        src={
          isFrance ? "images/MyLMX_Mouseover_fr.png" : "images/login_hover.jpg"
        }
      />
    </span>
  );
};

export default QuestionMark;
